import validate from "/usr/src/app/content/n3-packages-4df2fd93-96f6-4911-ab71-ce67743564de/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-4df2fd93-96f6-4911-ab71-ce67743564de/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}